export default __webpack_public_path__ + "static/media/SeaLife_09.374afd40.png";